import React from 'react';
import { motion } from "framer-motion";
import ScrollAnimation from "../components/animations/ScrollAnimation";
import { ParallaxBg } from "../components/ParallaxBg";
import { useTranslation } from 'react-i18next';
import { Link } from 'react-scroll';
import { usePageVariant, useSectionT } from "../contexts/PageVariantContext";

const COMPANY_BROCHURE_FILE = 'MJ_회사소개서(대외)_2026_v1.pdf';

const IT_HERO_BG =
  "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?ixlib=rb-1.2.1&auto=format&fit=crop&w=2000&q=80";

const Hero: React.FC = () => {
  const { t } = useTranslation();
  const variant = usePageVariant();
  const sectionT = useSectionT();
  const publicBase = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
  const brochureHref = `${publicBase}/${encodeURIComponent(COMPANY_BROCHURE_FILE)}`;
  const heroBg =
    variant === "rnd"
      ? `${publicBase}/pexels-concept-1868728.jpg`
      : IT_HERO_BG;

  return (
    <ParallaxBg 
      bgImage={heroBg}
      className="min-h-screen flex items-center pt-16 text-white"
    >
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 z-10 relative flex flex-row items-center">
        <div className="flex justify-start items-center">
          <ScrollAnimation>
            <div className="bg-gray-900/60 backdrop-blur-sm p-8 rounded-2xl shadow-xl w-fit min-h-[40vh] flex flex-col justify-center">
              <h1 className="font-poppins font-bold text-3xl sm:text-4xl md:text-4xl lg:text-4xl mb-6 leading-tight">
                <span className="gradient-text block sm:inline">{t(sectionT('hero.headline'))}</span>
                <span className="mt-2 block text-white sm:mt-3">{t(sectionT('hero.subheadline'))}</span>
              </h1>
              <p className="text-gray-300 text-md md:text-md mb-8">
                {t(sectionT('hero.description'))}
              </p>
              <div className="flex flex-wrap gap-4">
                <a
                  href={brochureHref}
                  download={COMPANY_BROCHURE_FILE}
                  className="inline-flex items-center justify-center px-8 py-3 bg-transparent hover:bg-white/10 border border-white text-white font-medium rounded-lg transition-colors cursor-pointer"
                >
                  {t(sectionT('hero.cta2'))}
                </a>
              </div>
            </div>
          </ScrollAnimation>
        </div>
        {variant === "it" ? (
        <div className="hidden md:block">
          <ScrollAnimation delay={0.3}>
            <div className="w-full h-[400px]">
              <lottie-player
                src="https://assets5.lottiefiles.com/packages/lf20_vckswclj.json"
                background="transparent"
                speed="1"
                style={{ width: "100%", height: "100%" }}
                loop
                autoplay
              ></lottie-player>
            </div>
          </ScrollAnimation>
        </div>
        ) : null}
        <div className="absolute bottom-[-100px] left-1/2 transform -translate-x-1/2 scroll-indicator">
          <Link
            to="services"
            smooth={true}
            duration={500}
            className="cursor-pointer"
          >
            <motion.svg
              className="w-8 h-8 text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              animate={{ y: [0, 10, 0] }}
              transition={{ duration: 2, repeat: Infinity }}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M19 14l-7 7m0 0l-7-7m7 7V3"
              ></path>
            </motion.svg>
          </Link>
        </div>
      </div>
    </ParallaxBg>
  );
};

export default Hero;
